import React from "react";
import { ReactComponent as JsIcon } from "../../assets/svgs/zed/file/javascript.svg";
import { ReactComponent as CssIcon } from "../../assets/svgs/zed/file/css.svg";
import { ReactComponent as HtmlIcon } from "../../assets/svgs/zed/file/html.svg";
import { ReactComponent as CodeIcon } from "../../assets/svgs/zed/file/code.svg";
import { ReactComponent as BookIcon } from "../../assets/svgs/zed/file/book.svg";
import { ReactComponent as ImageIcon } from "../../assets/svgs/zed/file/image.svg";
import { ReactComponent as AudioIcon } from "../../assets/svgs/zed/file/audio.svg";
import { ReactComponent as FontIcon } from "../../assets/svgs/zed/file/font.svg";
import { ReactComponent as LockIcon } from "../../assets/svgs/zed/file/lock.svg";
import { ReactComponent as GitIcon } from "../../assets/svgs/zed/file/git.svg";
import { ReactComponent as PlainIcon } from "../../assets/svgs/zed/file/file.svg";

// Zed's icons (from its repository, drawn from Lucide; see assets/svgs/zed/LICENSE).

const BY_EXTENSION = {
  js: JsIcon,
  jsx: JsIcon,
  css: CssIcon,
  html: HtmlIcon,
  json: CodeIcon,
  md: BookIcon,
  png: ImageIcon,
  jpg: ImageIcon,
  jpeg: ImageIcon,
  webp: ImageIcon,
  gif: ImageIcon,
  svg: ImageIcon,
  ico: ImageIcon,
  mp3: AudioIcon,
  ttf: FontIcon,
};

export { IMAGE } from "../../utils/project";

// A file's icon, as Zed's default icon theme picks it by name.
export const FileIcon = ({ name, ...props }) => {
  const Icon =
    name === ".gitignore"
      ? GitIcon
      : /-lock\.json$/.test(name)
        ? LockIcon
        : BY_EXTENSION[name.split(".").pop().toLowerCase()] || PlainIcon;
  return <Icon {...props} />;
};

export { ReactComponent as ArrowLeftIcon } from "../../assets/svgs/zed/arrow_left.svg";
export { ReactComponent as ArrowRightIcon } from "../../assets/svgs/zed/arrow_right.svg";
export { ReactComponent as BranchIcon } from "../../assets/svgs/zed/git_branch.svg";
export { ReactComponent as WorktreeIcon } from "../../assets/svgs/zed/git_worktree.svg";
export { ReactComponent as TerminalIcon } from "../../assets/svgs/zed/terminal.svg";
export { ReactComponent as PlusIcon } from "../../assets/svgs/zed/plus.svg";
export { ReactComponent as DashIcon } from "../../assets/svgs/zed/dash.svg";
export { ReactComponent as MaximizeIcon } from "../../assets/svgs/zed/maximize.svg";
export { ReactComponent as SplitIcon } from "../../assets/svgs/zed/split.svg";
export { ReactComponent as FileTreeIcon } from "../../assets/svgs/zed/file_tree.svg";
export { ReactComponent as ListTreeIcon } from "../../assets/svgs/zed/list_tree.svg";
export { ReactComponent as SearchIcon } from "../../assets/svgs/zed/magnifying_glass.svg";
export { ReactComponent as BoltIcon } from "../../assets/svgs/zed/bolt_outlined.svg";
export { ReactComponent as CheckIcon } from "../../assets/svgs/zed/check.svg";
export { ReactComponent as PredictIcon } from "../../assets/svgs/zed/zed_predict.svg";
export { ReactComponent as DebugIcon } from "../../assets/svgs/zed/debug.svg";
export { ReactComponent as UsersIcon } from "../../assets/svgs/zed/user_group.svg";
export { ReactComponent as AssistantIcon } from "../../assets/svgs/zed/zed_assistant.svg";
